define.alias("shared/components/shared/ui/notification-banner", "media/components/shared/ui/notification-banner");